import { Platform, StyleSheet } from 'react-native';

export default StyleSheet.create({
  headerTitleStyle: {
    fontFamily: Platform.OS === 'web' ? 'inherit' : undefined,
    fontWeight: 'bold',
    fontSize: 16,
  },
});
